import React, { useMemo } from 'react'

import { Table, TableRow } from '../../../../../components/pdf/Table'
import { TableColText, TableHeadText } from '../../../../../components/pdf/TableHelpers'
import Separator from '../../../../../components/pdf/Separator'
import Text from '../../../../../components/pdf/Text'
import View from '../../../../../components/pdf/View'
import {
  findReplyByQuestionName,
  getReplyValueFieldOrDefault,
  getDate,
  genCalibrationValidity
} from '../../_helpers/pdfHelpers'

const MeasuringEquipmentSection = ({ certify }) => {
  const certifyData = certify[0]

  const montarTipoMultifuncional = certifyData => {
    const denominacao = getReplyValueFieldOrDefault(
      findReplyByQuestionName(certifyData.replies, 'Qual a denominação do equipamento?')
    )
    const fabricante = getReplyValueFieldOrDefault(
      findReplyByQuestionName(certifyData.replies, 'Qual o fabricante do equipamento?')
    )
    const modelo = getReplyValueFieldOrDefault(
      findReplyByQuestionName(certifyData.replies, 'Qual o modelo do equipamento?')
    )
    const nroCertificado = getReplyValueFieldOrDefault(
      findReplyByQuestionName(certifyData.replies, 'Qual o número do certificado da calibração?')
    )
    const calibrationDate = findReplyByQuestionName(certifyData.replies, 'Qual a data da calibração?')
    const dataCalibracao = getDate(calibrationDate)
    const validadeCalibracao = genCalibrationValidity(
      certifyData.replies,
      'Qual a data da calibração?',
      'Qual a validade da calibração?'
    )

    return {
      ruido: {
        denominacao,
        fabricante,
        modelo,
        nroCertificado,
        dataCalibracao,
        validadeCalibracao
      },
      iluminacao: {
        denominacao,
        fabricante,
        modelo,
        nroCertificado,
        dataCalibracao,
        validadeCalibracao
      },
      temperatura: {
        denominacao,
        fabricante,
        modelo,
        nroCertificado,
        dataCalibracao,
        validadeCalibracao
      }
    }
  }

  const montarTipoOutros = certifyData => {
    return {
      ruido: {
        denominacao: getReplyValueFieldOrDefault(
          findReplyByQuestionName(certifyData.replies, 'Ruído - Qual a denominação do equipamento?')
        ),
        fabricante: getReplyValueFieldOrDefault(
          findReplyByQuestionName(certifyData.replies, 'Ruído - Qual o fabricante do equipamento?')
        ),
        modelo: getReplyValueFieldOrDefault(
          findReplyByQuestionName(certifyData.replies, 'Ruído - Qual o modelo do equipamento?')
        ),
        nroCertificado: getReplyValueFieldOrDefault(
          findReplyByQuestionName(certifyData.replies, 'Ruído - Qual o número do certificado da calibração?')
        ),
        dataCalibracao: getDate(findReplyByQuestionName(certifyData.replies, 'Ruído - Qual a data da calibração?')),
        validadeCalibracao: genCalibrationValidity(
          certifyData.replies,
          'Ruído - Qual a data da calibração?',
          'Ruído - Qual a validade da calibração?'
        )
      },
      iluminacao: {
        denominacao: getReplyValueFieldOrDefault(
          findReplyByQuestionName(certifyData.replies, 'Iluminância - Qual a denominação do equipamento?')
        ),
        fabricante: getReplyValueFieldOrDefault(
          findReplyByQuestionName(certifyData.replies, 'Iluminância - Qual o fabricante do equipamento?')
        ),
        modelo: getReplyValueFieldOrDefault(
          findReplyByQuestionName(certifyData.replies, 'Iluminância - Qual o modelo do equipamento?')
        ),
        nroCertificado: getReplyValueFieldOrDefault(
          findReplyByQuestionName(certifyData.replies, 'Iluminância - Qual o número do certificado da calibração?')
        ),
        dataCalibracao: getDate(
          findReplyByQuestionName(certifyData.replies, 'Iluminância - Qual a data da calibração?')
        ),
        validadeCalibracao: genCalibrationValidity(
          certifyData.replies,
          'Iluminância - Qual a data da calibração?',
          'Iluminância - Qual a validade da calibração?'
        )
      },
      temperatura: {
        denominacao: getReplyValueFieldOrDefault(
          findReplyByQuestionName(certifyData.replies, 'Temperatura e umidade - Qual a denominação do equipamento?')
        ),
        fabricante: getReplyValueFieldOrDefault(
          findReplyByQuestionName(certifyData.replies, 'Temperatura e umidade - Qual o fabricante do equipamento?')
        ),
        modelo: getReplyValueFieldOrDefault(
          findReplyByQuestionName(certifyData.replies, 'Temperatura e umidade - Qual o modelo do equipamento?')
        ),
        nroCertificado: getReplyValueFieldOrDefault(
          findReplyByQuestionName(
            certifyData.replies,
            'Temperatura e umidade - Qual o número do certificado da calibração?'
          )
        ),
        dataCalibracao: getDate(
          findReplyByQuestionName(certifyData.replies, 'Temperatura e umidade - Qual a data da calibração?')
        ),
        validadeCalibracao: genCalibrationValidity(
          certifyData.replies,
          'Temperatura e umidade - Qual a data da calibração?',
          'Temperatura e umidade - Qual a validade da calibração?'
        )
      }
    }
  }

  const data = useMemo(() => {
    if (!certifyData) {
      return {
        ruido: {
          denominacao: '',
          fabricante: '',
          modelo: '',
          nroCertificado: '',
          dataCalibracao: '',
          validadeCalibracao: ''
        },
        iluminacao: {
          denominacao: '',
          fabricante: '',
          modelo: '',
          nroCertificado: '',
          dataCalibracao: '',
          validadeCalibracao: ''
        },
        temperatura: {
          denominacao: '',
          fabricante: '',
          modelo: '',
          nroCertificado: '',
          dataCalibracao: '',
          validadeCalibracao: ''
        }
      }
    }
    const tipoEquipamento = findReplyByQuestionName(certifyData.replies, 'Qual o tipo de equipamento?')

    if (tipoEquipamento.value.name === 'Multifuncional') {
      return montarTipoMultifuncional(certifyData)
    }
    return montarTipoOutros(certifyData)
  }, [certifyData])

  return (
    <View noWrap id="8">
      <Text bold size="small">
        8. EQUIPAMENTOS DE MEDIÇÃO
      </Text>

      <Separator weight={4} />

      <Table width="100%">
        <TableRow>
          <TableHeadText rowSpan={2}>Instrumento de Medição</TableHeadText>
          <TableHeadText colSpan={3}>Equipamento</TableHeadText>
          <TableHeadText colSpan={3}>Calibração</TableHeadText>
        </TableRow>

        <TableRow>
          <TableHeadText>Denominação</TableHeadText>
          <TableHeadText>Fabricante</TableHeadText>
          <TableHeadText>Modelo</TableHeadText>

          <TableHeadText>N. Certificado</TableHeadText>
          <TableHeadText>Data</TableHeadText>
          <TableHeadText>Validade</TableHeadText>
        </TableRow>

        <TableRow>
          <TableColText>Ruído</TableColText>
          <TableColText>{data.ruido.denominacao}</TableColText>
          <TableColText>{data.ruido.fabricante}</TableColText>
          <TableColText>{data.ruido.modelo}</TableColText>
          <TableColText>{data.ruido.nroCertificado}</TableColText>
          <TableColText>{data.ruido.dataCalibracao}</TableColText>
          <TableColText>{data.ruido.validadeCalibracao}</TableColText>
        </TableRow>

        <TableRow>
          <TableColText>Iluminação</TableColText>
          <TableColText>{data.iluminacao.denominacao}</TableColText>
          <TableColText>{data.iluminacao.fabricante}</TableColText>
          <TableColText>{data.iluminacao.modelo}</TableColText>
          <TableColText>{data.iluminacao.nroCertificado}</TableColText>
          <TableColText>{data.iluminacao.dataCalibracao}</TableColText>
          <TableColText>{data.iluminacao.validadeCalibracao}</TableColText>
        </TableRow>

        <TableRow>
          <TableColText>Temperatura e umidade</TableColText>
          <TableColText>{data.temperatura.denominacao}</TableColText>
          <TableColText>{data.temperatura.fabricante}</TableColText>
          <TableColText>{data.temperatura.modelo}</TableColText>
          <TableColText>{data.temperatura.nroCertificado}</TableColText>
          <TableColText>{data.temperatura.dataCalibracao}</TableColText>
          <TableColText>{data.temperatura.validadeCalibracao}</TableColText>
        </TableRow>
      </Table>

      <Separator weight={8} />
    </View>
  )
}

export default MeasuringEquipmentSection
